import React from 'react';
import moment from 'moment-timezone';
import IconValueWarning from '../../../components/ui_components/table/IconValue/IconValueWarning'
import IconTooltip from '../../../components/ui_components/IconTooltip/IconTooltip'
import { formatServerDateTimeToLocal } from '../../../utils/dateTimeFormat'
import helpers from '../../../utils/helpers'

const usersTableColumns = [
  {
    id: "userFirstName",
    label: "First Name",
  },
  {
    id: "userLastName",
    label: "Last Name",
  },
  {},
  {
    id: "userName",
    label: "Username",
  },
  {
    id: "userEmail",
    label: "Email",
  },
  {
    id: "userRoleDesc",
    label: "Role",
  },
  {
    id: "userStatusDesc",
    label: "Status",
  },
  {
    id: 'userCreateDate',
    label: 'Date Added',
    accessor: (d) => formatServerDateTimeToLocal(d.userCreateDate, 'date'),
  },
  {
    id: 'lastLogonDate',
    label: 'Last Login Date',
    accessor: (d) => formatServerDateTimeToLocal(d.lastLogonDate, 'dateTime'),
  },
  {
    id: 'tempPwdExpiredDate',
    label: 'Temp Password Expiration Date',
    style: {
      display: 'flex',
      justifyContent: 'center',
    },
    accessor: (d) => {
      if (!d.tempPwdExpiredDate) {
        return;
      }
      const expirationDate = formatServerDateTimeToLocal(d.tempPwdExpiredDate, 'date');

      const issueReasonDescs = helpers.stringToArr(d.issueReasonDescs || d.issueDescs);
      const issueCodesArray = helpers.stringToArr(d.issueReasonCodes || d.issueCodes || d.issueReasonCode || d.issueCode);

      const descriptions = issueReasonDescs.map((desc, index) => {
        const code = issueCodesArray[index];
        const displayValue = code && code.trim() !== '' ? `${code.trim()} - ${desc}` : desc;
        return <div key={index}>{displayValue}</div>;
      });

      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ paddingRight: 5 }}>
            {expirationDate}
          </span>
          {moment(expirationDate).unix() <= moment().unix() && (
            <IconTooltip title={
              <React.Fragment>
                {descriptions.length > 0 ? (
                  <React.Fragment>
                    <strong>Issues:</strong>
                    {descriptions}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    Temporary Password Expired: {expirationDate}
                  </React.Fragment>
                )}
              </React.Fragment>
            }>
              <IconValueWarning />
            </IconTooltip>
          )}
        </div>
      )
    }
  }
];

export default usersTableColumns;
